import React, { HTMLAttributes } from 'react';

import {
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import { DynamicMediaItem } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { ParagraphUSPSubparagraph as Type } from '../../../types/uncinc_profile/paragraphs';

import { LottieInline } from '../../../components';

import './style.scss';

interface ParagraphUSPSubparagraphProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphUSPSubparagraph: React.FC<ParagraphUSPSubparagraphProps> = ({
  entity,
}) => {
  const paragraph = entity.toJS();

  const title = paragraph.field_title[0]?.value;
  const body = paragraph.field_body[0]?.processed;
  const media = paragraph.field_media_item[0];
  const imageAlt = media.bundle === 'svg' ? media.entity?.field_media_svg?.[0]?.alt : undefined;
  const imageAriaLabelLottie = media.bundle === 'lottie' ? media.entity?.field_caption?.[0]?.value : undefined;

  return (
    <div className="ParagraphUSPSubparagraph">
      <div className="ParagraphUSPSubparagraph__image">
        {media.bundle === 'lottie' ? (
          <LottieInline
            url={media.entity.field_media_file[0].source}
            lottieId={title.toLowerCase().replace(/ /g, '-')}
            ariaLabel={imageAriaLabelLottie}
          />
        ) : (
          <DynamicMediaItem
            media={media}
            imageAspectRatio="1_1"
            alt={imageAlt}
          />
        )}
      </div>

      <h3 className="ParagraphUSPSubparagraph__title">{title}</h3>
      {(body) && <WysiwygField html={body} />}
    </div>
  );
};

export default ParagraphUSPSubparagraph;
